import { orderNumberConstants } from '../Constants';
import { orderNumberServices } from '../Services';

export const orderNumberActions = {
    orderNumber,
};

function orderNumber(data: any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: orderNumberConstants.ORDER_NUMBER_REQUEST,
            data: null
        }));
        orderNumberServices.orderNumber(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: orderNumberConstants.ORDER_NUMBER_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: orderNumberConstants.ORDER_NUMBER_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: orderNumberConstants.ORDER_NUMBER_FAILURE,
                        data: error.response && error.response.data ? error.response.data.message : "There is some error"
                    }));
                }
            );
    };
}



function dispatchFunction(data: any) {
    // To do: check for refresh / unauthorized error
    return {
        type: data.type,
        data: data.data
    };
}